// @ts-nocheck
import cn from 'clsx'
import { string } from 'prop-types'
import { type FC } from 'react'

import { isCdnUrlHook } from 'shared/utils/imageUtils'
import { type InferPropsWithDefaults } from 'shared/utils/propTypes'
import CdnImage from 'views/components/atoms/CdnImage'
import Image from 'views/components/atoms/Image'

const propTypes = {
  src: string.isRequired,
  alt: string.isRequired,
  className: string,
}

type Props = InferPropsWithDefaults<typeof propTypes>

const MIN_SIZE_PX = 152
const MAX_SIZE_PX = 224

const Logo: FC<Props> = props => {
  const { src, alt, className } = props

  if (!src) {
    return null
  }

  if (!isCdnUrlHook(src)) {
    return (
      <Image
        alt={alt}
        src={src}
        width={MAX_SIZE_PX}
        height={MAX_SIZE_PX}
        className={cn('max100width-image', className)}
        // lazy loading, because it might be hidden by the CSS
        lazyLoad
      />
    )
  }

  return (
    <CdnImage
      alt={alt}
      fileName={src}
      minWidth={MIN_SIZE_PX}
      maxWidth={MAX_SIZE_PX}
      maxHeight={MAX_SIZE_PX}
      sizes={{
        base: '25vw', // It’s actually hidden below “medium”, see below
      }}
      imgClassName={cn('max100width-image', className)}
      // lazy loading, because it might be hidden by the CSS
      lazyLoad
    />
  )
}

Logo.propTypes = propTypes

export default Logo
